import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import SideModalClose from "./side-modal-close";
import { twMerge } from "tailwind-merge";

// TODO: add slide in and out animation
function SlideModal({
  close,
  children,
  styles = {},
  open,
  className = "",
  dialogClassName = "",
  closeClassName = "",
  closeStroke = "#000",
  headerClassName = "",
}) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  const modalAnimation = {
    hidden: {
      y: "100%",
    },
    visible: {
      y: "0%",
    },
    exit: {
      y: "100%",
    },
  };
  return (
    <>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{
              backgroundColor: "rgba(0, 0, 0, 0)",
              backdropFilter: "blur(0px)",
              // zIndex: 100,
            }}
            animate={{
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(5px)",
            }}
            exit={{
              backgroundColor: "rgba(0, 0, 0, 0)",
              backdropFilter: "blur(0px)",
            }}
            tabIndex={-1}
            className={twMerge(
              "fixed top-0 right-0 left-0 z-50 inset-0",
              dialogClassName
            )}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              backdropFilter: "blur(5px)",
            }}
          >
            <div
              area-hidden="true"
              className={twMerge(`absolute w-full h-20 z-[1]`, headerClassName)}
              onClick={close}
            />
            {/* <button
              className="absolute right-5 top-6 bg-white w-11 h-11 flex justify-center items-center rounded-full hover:bg-white/80 transition-all hover:scale-[1.025] z-[2]"
              onClick={close}
            >
              <CloseIcon stroke="#000" />
            </button> */}
            <SideModalClose
              onClick={close}
              className={closeClassName}
              closeStroke={closeStroke}
            />
            <motion.div
              className={twMerge(
                `bg-gray-150 shadow dark:bg-gray-700 overflow-y-auto relative mt-20 pb-20`,
                className
              )}
              // style={{ height: "calc(100% - 80px)", ...styles }}
              style={{ height: "calc(100% - 40px)", ...styles }}
              id="page-container"
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={modalAnimation}
            >
              <>{children}</>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default React.memo(SlideModal);
